export const CITIZENSHIP_VALUES = [
  'Гражданин РФ',
  'Гражданин РФ и иностранного государства (двойное гражданство)',
  'Иностранный гражданин',
  'Лицо без гражданства'
];

export const CITIZENSHIP_TYPE = {
  CITIZEN: 'CITIZEN',
  FOREIGN_CITIZEN: 'FOREIGN_CITIZEN',
  NON_CITIZEN: 'NON_CITIZEN',
  DUAL: 'DUAL'
};

export const CITIZENSHIP_TYPES = {
  [CITIZENSHIP_VALUES[0]]: CITIZENSHIP_TYPE.CITIZEN,
  [CITIZENSHIP_VALUES[1]]: CITIZENSHIP_TYPE.DUAL,
  [CITIZENSHIP_VALUES[2]]: CITIZENSHIP_TYPE.FOREIGN_CITIZEN,
  [CITIZENSHIP_VALUES[3]]: CITIZENSHIP_TYPE.NON_CITIZEN
};

export const CITIZENSHIP_TYPE_VALUES = Object.keys(CITIZENSHIP_TYPES).reduce(
  (accum, key) => {
    return {
      ...accum,
      [CITIZENSHIP_TYPES[key]]: key
    };
  },
  {}
);

/**
 * требования тут https://olymp-moscow.atlassian.net/wiki/spaces/PRODUCTS/pages/462389423
 *
 * Доступные типы документов
 * @const
 * @type {object}
 * @property {string} PASSPORT_RF Паспорт гражданина РФ
 * @property {string} TEMPORARY_ID Временное удостоверение личности
 * @property {string} FOREIGN_PASSPORT Паспорт иностранног ообразца
 * @property {string} REFUGEE_SOLICITATION Свидетельство о регистрации ходатайства иммигранта
 * о признании его беженцем
 * @property {string} REFUGEE_ID Удостоверение беженца
 * @property {string} FOREIGN_ID Документ, удостоверяющий личность иностранного гражданина
 * @property {string} NON_CITIZEN_ID Документ, удостоверяющий личность лица без гражданства
 * @property {string} TEMPORARY_RESIDENT_PERMIT Разрешение на временное проживание
 * @property {string} RESIDENCE Вид на жительство в РФ
 * @property {string} OFFICER_ID Удостоверение личности офицера
 * @property {string} PRISON_RELEASE_CERTIFICATE Справка об освобождении из мест лишения свободы
 */
export const DOCUMENT_TYPE = {
  PASSPORT_RF: 'PASSPORT_RF',
  INTERNATIONAL_PASSPORT_RF: 'INTERNATIONAL_PASSPORT_RF',
  TEMPORARY_ID: 'TEMPORARY_ID',
  DIPLOMATIC_PASSPORT: 'DIPLOMATIC_PASSPORT',
  SERVICE_PASSPORT: 'SERVICE_PASSPORT',
  MILITARY_ID: 'MILITARY_ID',
  OFFICER_ID: 'OFFICER_ID',
  FOREIGN_PASSPORT: 'FOREIGN_PASSPORT',
  REFUGEE_ID: 'REFUGEE_ID',
  TEMPORARY_REFUGEE_PERMIT: 'TEMPORARY_REFUGEE_PERMIT',
  TEMPORARY_RESIDENT_PERMIT: 'TEMPORARY_RESIDENT_PERMIT',
  RESIDENCE: 'RESIDENCE',
  FOREIGN_NON_CITIZEN_DOC: 'FOREIGN_NON_CITIZEN_DOC',
  RF_NON_CITIZEN_DOC: 'RF_NON_CITIZEN_DOC',
  REFUGEE_CONSIDERATION: 'REFUGEE_CONSIDERATION',
  BIRTH_CERTIFICATE_RF: 'BIRTH_CERTIFICATE_RF',
  BIRTH_CERTIFICATE_INTERNATIONAL: 'BIRTH_CERTIFICATE_INTERNATIONAL'
  // SEAMAN_PASSPORT_RF: 'SEAMAN_PASSPORT_RF',
  // FOREIGN_ID: 'FOREIGN_ID',
  // NON_CITIZEN_ID: 'NON_CITIZEN_ID',
  // REFUGEE_SOLICITATION: 'REFUGEE_SOLICITATION',
  // PRISON_RELEASE_CERTIFICATE: 'PRISON_RELEASE_CERTIFICATE'
};

export const DOCUMENTS_BY_CITIZENSHIP = {
  [CITIZENSHIP_TYPE.CITIZEN]: [
    DOCUMENT_TYPE.PASSPORT_RF,
    DOCUMENT_TYPE.INTERNATIONAL_PASSPORT_RF,
    DOCUMENT_TYPE.DIPLOMATIC_PASSPORT,
    DOCUMENT_TYPE.SERVICE_PASSPORT,
    DOCUMENT_TYPE.OFFICER_ID,
    DOCUMENT_TYPE.TEMPORARY_ID,
    DOCUMENT_TYPE.MILITARY_ID,
    DOCUMENT_TYPE.BIRTH_CERTIFICATE_RF
  ],
  [CITIZENSHIP_TYPE.FOREIGN_CITIZEN]: [
    DOCUMENT_TYPE.FOREIGN_PASSPORT,
    DOCUMENT_TYPE.TEMPORARY_RESIDENT_PERMIT,
    DOCUMENT_TYPE.RESIDENCE,
    DOCUMENT_TYPE.RF_NON_CITIZEN_DOC,
    DOCUMENT_TYPE.REFUGEE_ID,
    DOCUMENT_TYPE.REFUGEE_CONSIDERATION,
    DOCUMENT_TYPE.TEMPORARY_REFUGEE_PERMIT,
    DOCUMENT_TYPE.BIRTH_CERTIFICATE_INTERNATIONAL
  ],
  [CITIZENSHIP_TYPE.NON_CITIZEN]: [
    DOCUMENT_TYPE.FOREIGN_NON_CITIZEN_DOC,
    DOCUMENT_TYPE.TEMPORARY_RESIDENT_PERMIT,
    DOCUMENT_TYPE.RESIDENCE,
    DOCUMENT_TYPE.RF_NON_CITIZEN_DOC,
    DOCUMENT_TYPE.REFUGEE_ID,
    DOCUMENT_TYPE.REFUGEE_CONSIDERATION,
    DOCUMENT_TYPE.TEMPORARY_REFUGEE_PERMIT,
    DOCUMENT_TYPE.BIRTH_CERTIFICATE_INTERNATIONAL
  ],
  [CITIZENSHIP_TYPE.DUAL]: [
    DOCUMENT_TYPE.PASSPORT_RF,
    DOCUMENT_TYPE.INTERNATIONAL_PASSPORT_RF,
    DOCUMENT_TYPE.DIPLOMATIC_PASSPORT,
    DOCUMENT_TYPE.SERVICE_PASSPORT,
    DOCUMENT_TYPE.OFFICER_ID,
    DOCUMENT_TYPE.TEMPORARY_ID,
    DOCUMENT_TYPE.MILITARY_ID,
    DOCUMENT_TYPE.BIRTH_CERTIFICATE_RF,
    DOCUMENT_TYPE.BIRTH_CERTIFICATE_INTERNATIONAL
  ]
};

export const MAIN_DATA_FIELD_NAMES = {
  birthRegistrationPlace: 'birth_reg_place'
};

export const BIRTH_REG_PLACES_VALUES = {
  RF: 'RF',
  FOREIGN: 'FOREIGN'
};

export const BIRTH_REG_PLACES = {
  PLACEHOLDER: 'Место регистрации рождения',
  NAME: MAIN_DATA_FIELD_NAMES.birthRegistrationPlace,
  VALUES: {
    [BIRTH_REG_PLACES_VALUES.RF]: {
      value: BIRTH_REG_PLACES_VALUES.RF,
      text: 'Российская Федерация'
    },
    [BIRTH_REG_PLACES_VALUES.FOREIGN]: {
      value: BIRTH_REG_PLACES_VALUES.FOREIGN,
      text: 'Иностранное государство'
    }
  }
};
